import { z } from "zod";

/** A user may star at most this many markets; the API rejects the next one. */
export const ARENA_MARKET_FAVORITES_MAX = 50;

/** Canonical CCXT perp key, e.g. "BTC/USDC:USDC" — one star covers that pair in every duel. */
export const ArenaFavoritePairSymbolSchema = z
  .string()
  .trim()
  .max(64)
  .regex(/^[A-Z0-9._-]+\/([A-Z0-9._-]+):\1$/, "pairSymbol must look like BTC/USDC:USDC");

export const ArenaMarketFavoriteBodySchema = z.object({ pairSymbol: ArenaFavoritePairSymbolSchema });
export type ArenaMarketFavoriteBody = z.infer<typeof ArenaMarketFavoriteBodySchema>;

/** Starred pairs, oldest first. May include pairs the current duel doesn't offer. */
export const ArenaMarketFavoritesSchema = z.object({ pairSymbols: z.array(ArenaFavoritePairSymbolSchema) });
export type ArenaMarketFavoritesDto = z.infer<typeof ArenaMarketFavoritesSchema>;

/**
 * Error codes the market-favorites endpoints return in the RFC 9457 `type` field. The API's
 * `ArenaMarketFavoritesErrorCode` derives from this, so the two cannot drift.
 */
export const ARENA_MARKET_FAVORITES_ERROR_CODE = {
  MARKET_NOT_OFFERED: "ARENA_MARKET_NOT_OFFERED",
  LIMIT_REACHED: "ARENA_MARKET_FAVORITES_LIMIT_REACHED",
} as const;
export type ARENA_MARKET_FAVORITES_ERROR_CODE =
  (typeof ARENA_MARKET_FAVORITES_ERROR_CODE)[keyof typeof ARENA_MARKET_FAVORITES_ERROR_CODE];
